import type { Work } from "@/types";
import SectionHeading from "./SectionHeading";
import { works } from "@/mocks/works";

const featuredIds = ["w08", "w04", "w13"];
const featured: Work[] = featuredIds
  .map((id) => works.find((w) => w.id === id))
  .filter((w): w is Work => Boolean(w));

const [lead, ...rest] = featured;

export default function FeaturedSection() {
  return (
    <section id="featured" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="精选推荐 · 编辑策展"
          title="口碑在线，值得单独推荐的三部"
          desc="从榜单与更新之外，我们按完成度、画风与叙事节奏挑出少量作品，适合想认真读一本、而不是随手翻翻的读者。"
          tone="accent"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-5 gap-5">
          {lead && (
            <article className="lg:col-span-3 flex flex-col sm:flex-row rounded-lg border border-background-200/70 bg-background-100/50 overflow-hidden">
              <div className="w-full sm:w-56 aspect-[3/4] sm:aspect-auto shrink-0 bg-background-200">
                <img
                  src={lead.cover}
                  alt={`《${lead.title}》漫画封面`}
                  title={`${lead.title} 漫画 免费在线观看`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col p-5 md:p-6 gap-3 flex-1">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 text-background-50 text-xs px-3 py-1">
                    <i className="ri-medal-line" aria-hidden="true"></i>
                    编辑力荐
                  </span>
                  <span className="rounded-full bg-primary-100 text-primary-700 text-xs px-2.5 py-0.5">{lead.category}</span>
                </div>
                <h3 className="font-heading text-foreground-950 text-2xl md:text-3xl leading-tight">{lead.title}</h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">{lead.description}</p>
                <div className="mt-auto grid grid-cols-3 gap-3 pt-3 border-t border-background-200/70">
                  <div>
                    <p className="text-foreground-500 text-xs">评分</p>
                    <p className="font-heading text-primary-600 text-xl">{lead.rating}</p>
                  </div>
                  <div>
                    <p className="text-foreground-500 text-xs">阅读量</p>
                    <p className="font-heading text-foreground-900 text-xl">{lead.views}</p>
                  </div>
                  <div>
                    <p className="text-foreground-500 text-xs">状态</p>
                    <p className="text-foreground-900 text-sm mt-1.5">{lead.status}</p>
                  </div>
                </div>
              </div>
            </article>
          )}

          <div className="lg:col-span-2 flex flex-col gap-5">
            {rest.map((work) => (
              <article
                key={work.id}
                className="flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 hover:border-primary-300 transition-colors"
              >
                <div className="w-20 h-28 rounded-md overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={work.cover}
                    alt={`《${work.title}》漫画封面`}
                    title={`${work.title} 漫画 免费在线观看`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col gap-1.5 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-primary-100 text-primary-700 text-xs px-2 py-0.5 whitespace-nowrap">{work.category}</span>
                    <span className="text-foreground-500 text-xs inline-flex items-center gap-1">
                      <i className="ri-star-fill text-primary-400" aria-hidden="true"></i>
                      {work.rating}
                    </span>
                  </div>
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate">{work.title}</h3>
                  <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-3">{work.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}